import request from '@/utils/request'


export function GetAllUserRoles(branchId) {
    return request({
        url: '/UserRole/GetAllUserRoles',
        method: 'post',
        data: {
            BranchId: branchId
        }

    })
}

export function SaveRole(id, branchId, fardId, isActive, role) {
    return request({
        url: '/UserRole/Save',
        method: 'post',
        data: {
            Id: id,
            BranchId: parseInt(branchId),
            FardId: fardId,
            Role: role,
            IsActive: isActive
        }

    })
}

export function DeleteRole(id) {
    return request({
        url: '/UserRole/Delete',
        method: 'post',
        data: {
            Id: id,
           
        }

    })
}